<template>
    <div class="page">

        <z-update-template-basic ref="updateTemplateBasic" @updateSuccess="refreshTemplate"></z-update-template-basic>
        <z-update-basic-config ref="updateBasicConfig" @updateSuccess="refreshTemplate"></z-update-basic-config>
        <z-update-smart-config ref="updateSmartConfig" @updateSuccess="refreshTemplate"></z-update-smart-config>
        <z-add-rule-template ref="addRuleTemplate" @addSuccess="refreshTemplate"></z-add-rule-template>
        <z-edit-fence ref="editFence" @updateSuccess="refreshTemplate"></z-edit-fence>
        <a-row :gutter="24">
            <a-col span="6">
                <div class="content chooser" v-if="!isSuperAdmin">
                    <label>{{$t('global.org')}}</label>
                    <z-org-chooser :option="orgOption" @orgSelect="onOrgSelect"></z-org-chooser>
                </div>

                <div class="content group-list">
                    <a-row :gutter="24" v-if="templates.length > 0">
                        <a-col :md="{span:24}" :lg="{span:24}" v-for="item in templates" :key="item.entityGroup.id">
                            <a style="margin:20px;">
                                <a-card :class="item.entityGroup.id == org.defaultEntityGroupId ? 'current' : ''" style="margin-top:10px" hoverable
                                    @click="setCurrent(item)">
                                    <a-card-meta :description="item.entityGroup.description">
                                        <div class="avatar-icon" slot="avatar" >
                                          <i class="icon-custom icon-online">
                                            <zx-icon type="icon-renyuanfenzuguanli"></zx-icon>
                                          </i>
                                        </div>
                                        <div slot="title">
                                            {{item.entityGroup.name}}
                                            <!-- {{$t(`global.${item.entityGroup.name}`)}} -->
                                            <span class="subText" v-if="roles === 'Org' && item.entityGroup.aliasName">(
                                                {{item.entityGroup.aliasName}}
                                            )
                                            </span>
                                        </div>
                                    </a-card-meta>
                                    <template class="ant-card-actions"  slot="actions">
                                        <a-checkbox :checked="item.entityGroup.id == org.defaultEntityGroupId"
                                            :disabled="item.entityGroup.id == org.defaultEntityGroupId || item.entityGroup.id != currentTemplate.entityGroup.id"
                                            @change="changeDefaultGroup(item.entityGroup.id)">{{$t('supervise.defaultGroup')}}</a-checkbox>
                                        <a-popconfirm @confirm="deleteGroup(item.entityGroup.id)" :title="$t('global.confirm')"
                                            :okText="$t('global.yes')" :cancelText="$t('global.no')">
                                            <a-button
                                                :disabled="item.entityGroup.id == org.defaultEntityGroupId || item.entityGroup.id != currentTemplate.entityGroup.id"
                                                type="danger" size="small">
                                                <zx-icon type="icon-picture-delet"></zx-icon> {{$t('global.delete')}}
                                            </a-button>
                                        </a-popconfirm>
                                    </template>
                                </a-card>
                            </a>
                        </a-col>
                        <!-- 添加分组模板 超管权限 -->
                        <a-col :md="{span:24}" :lg="{span:24}"
                            v-if="!isSuperAdmin && org && org.link.split(',').length == 4 && templates.length < 5">
                            <div style="margin:20px;">
                                <a-card hoverable style="min-height: 131px;text-align: center;padding-top:19px;margin-top:10px"
                                    @click="addRuleTemplate">
                                    <a-icon :style="{ fontSize: '36px' }" type="plus" />
                                </a-card>
                            </div>
                        </a-col>
                    </a-row>
                </div>
            </a-col>

            <a-col span="18">
                 <div  class="content" v-if="currentTemplate">
                        <a-tabs defaultActiveKey="info">
                            <a-tab-pane :tab="$t('global.basicInfo')" key="info">
                                <a-card>
                                    <div style="font-weight:500;font-size:18px">
                                        {{$t('global.basicInfo')}}
                                        <a-button style="left:5%" type="primary" icon="edit" size="small"
                                            @click="editTemplateBasic">{{$t('global.edit')}}</a-button>
                                    </div>
                                    <a-divider />

                                    <a-row :gutter="24" style="margin-left: -16px; margin-right: -16px;margin-top:25px">
                                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}"
                                            :lg="{span:24}">
                                            <div class="antd-pro-components-description-list-index-term"
                                                style="white-space: nowrap">{{$t('supervise.groupName')}}</div>
                                            <div class="antd-pro-components-description-list-index-detail">
                                                {{currentTemplate.entityGroup.name}}
                                                <!-- {{$t(`global.${currentTemplate.entityGroup.name}`)}} -->
                                                <span class="subText" v-if="roles === 'Org' && currentTemplate.entityGroup.aliasName">(
                                                    {{currentTemplate.entityGroup.aliasName}}
                                                )
                                                </span>
                                            </div>
                                        </a-col>

                                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}"
                                            :lg="{span:24}">
                                            <div class="antd-pro-components-description-list-index-term"
                                                style="white-space: nowrap">{{$t('supervise.groupDescription')}}</div>
                                            <div class="antd-pro-components-description-list-index-detail">
                                                {{currentTemplate.entityGroup.description}}</div>
                                        </a-col>
                                    </a-row>
                                </a-card>
                            </a-tab-pane>

                            <a-tab-pane :tab="$t('supervise.option')" key="set">
                                <a-card style="margin-top:10px">
                                    <div style="font-weight:500;font-size:18px">
                                        {{$t('supervise.option')}}
                                        <a-button style="left:5%" type="primary" icon="edit" size="small" @click="editBasicRule">{{$t('global.edit')}}
                                        </a-button>
                                    </div>
                                    <a-divider />

                                    <a-row :gutter="24" style="margin-left: -16px; margin-right: -16px;margin-top:25px">
                                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}"
                                            :lg="{span:24}">
                                            <div class="antd-pro-components-description-list-index-term"
                                                style="white-space: nowrap">{{$t('supervise.locateFreq')}}</div>
                                            <div class="antd-pro-components-description-list-index-detail">
                                                {{currentTemplate.ruleTemplate[0].locateFreq ? currentTemplate.ruleTemplate[0].locateFreq/60 + $t('global.minute') : `30${$t('global.minute')}`}}
                                            </div>
                                        </a-col>

                                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}"
                                            :lg="{span:24}">
                                            <div class="antd-pro-components-description-list-index-term"
                                                style="white-space: nowrap">{{$t('supervise.autoAdjust')}}</div>
                                            <div class="antd-pro-components-description-list-index-detail">
                                                {{currentTemplate.ruleTemplate[0].autoAdjust ? $t('global.enable') : $t('global.disable')}}</div>
                                        </a-col>

                                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}"
                                            :lg="{span:24}">
                                            <div class="antd-pro-components-description-list-index-term"
                                                style="white-space: nowrap">{{$t('supervise.autoPowerUp')}}</div>
                                            <div class="antd-pro-components-description-list-index-detail">
                                                {{currentTemplate.ruleTemplate[0].autoPowerUp ? formatTime(currentTemplate.ruleTemplate[0].autoPowerUp) : $t('global.none')}}</div>
                                        </a-col>

                                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}"
                                            :lg="{span:24}">
                                            <div class="antd-pro-components-description-list-index-term"
                                                style="white-space: nowrap">{{$t('supervise.autoPowerDown')}}</div>
                                            <div class="antd-pro-components-description-list-index-detail">
                                                {{currentTemplate.ruleTemplate[0].autoPowerDown ? formatTime(currentTemplate.ruleTemplate[0].autoPowerDown) : $t('global.none')}}</div>
                                        </a-col>

                                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}"
                                            :lg="{span:24}">
                                            <div class="antd-pro-components-description-list-index-term"
                                                style="white-space: nowrap">{{$t('supervise.customLocate')}}</div>
                                            <div class="antd-pro-components-description-list-index-detail">
                                                {{currentTemplate.ruleTemplate[0].customLocate && currentTemplate.ruleTemplate[0].customLocate.length > 0 ? $t('global.enable') : $t('global.none')}}
                                            </div>
                                        </a-col>

                                        <template
                                            v-if="currentTemplate.ruleTemplate[0].customLocate && currentTemplate.ruleTemplate[0].customLocate.length > 0">
                                            <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}"
                                            :lg="{span:24}">
                                                <div class="antd-pro-components-description-list-index-term"
                                                    style="white-space: nowrap">{{$t('supervise.segmentTime')}}</div>
                                                <div class="antd-pro-components-description-list-index-detail">
                                                    {{formatTime(currentTemplate.ruleTemplate[0].customLocate[0].startTime) + '~' + formatTime(currentTemplate.ruleTemplate[0].customLocate[0].endTime)}}
                                                </div>
                                            </a-col>

                                            <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}"
                                            :lg="{span:24}">
                                                <div class="antd-pro-components-description-list-index-term"
                                                    style="white-space: nowrap">{{$t('supervise.segmentFreq')}}</div>
                                                <div class="antd-pro-components-description-list-index-detail">
                                                    {{currentTemplate.ruleTemplate[0].customLocate[0].intervalTime / 60 + $t('global.minute')}}
                                                </div>
                                            </a-col>

                                        </template>
                                    </a-row>
                                </a-card>
                            </a-tab-pane>

                            <a-tab-pane :tab="$t('supervise.smartRule')" key="supervise">
                                <a-card style="margin-top:10px">
                                    <div style="font-weight:500;font-size:18px">
                                        {{$t('supervise.smartRule')}}
                                        <a-button style="left:5%" type="primary" icon="edit" size="small" @click="editSmartRule">{{$t('global.edit')}}
                                        </a-button>
                                    </div>
                                    <a-divider />

                                    <a-row :gutter="24" style="margin-left: -16px; margin-right: -16px;margin-top:25px">
                                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}"
                                            :lg="{span:24}">
                                            <div class="antd-pro-components-description-list-index-term"
                                                style="white-space: nowrap">{{$t('supervise.timeingName')}}</div>
                                            <div class="antd-pro-components-description-list-index-detail"
                                                v-if="currentTemplate.ruleTemplate[0].rollCall">
                                                <a-tag v-for="(item,index) in currentTemplate.ruleTemplate[0].rollCall" :key="index"
                                                    color="blue">{{formatTime(item)}}</a-tag>
                                            </div>
                                            <div v-else class="antd-pro-components-description-list-index-detail">{{$t('global.none')}}</div>
                                        </a-col>

                                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}"
                                            :lg="{span:24}">
                                            <div class="antd-pro-components-description-list-index-term"
                                                style="white-space: nowrap">{{$t('supervise.timeingHeart')}}</div>
                                            <div class="antd-pro-components-description-list-index-detail"
                                                v-if="currentTemplate.ruleTemplate[0].heartRate">
                                                <a-tag v-for="(item,index) in currentTemplate.ruleTemplate[0].heartRate"
                                                    :key="index" color="blue">{{formatTime(item)}}</a-tag>
                                            </div>
                                            <div v-else class="antd-pro-components-description-list-index-detail">{{$t('global.none')}}</div>
                                        </a-col>
                                    </a-row>
                                </a-card>
                            </a-tab-pane>

                            <a-tab-pane :tab="$t('supervise.mapFence')" key="fence">
                                <a-card style="margin-top:10px" >
                                    <div style="font-weight:500;font-size:18px">
                                        {{$t('supervise.mapFence')}}
                                        <a-button v-if="ownFences && ownFences.length < 11" style="left:5%" type="primary" icon="plus" size="small" @click="addFence">  {{$t('global.create')}}
                                        </a-button>
                                    </div>
                                    <a-divider />
                                    
                                    <div v-if="inheritFences && inheritFences.length > 0">
                                      <div style="font-weight:500;font-size:18px">{{$t('supervise.inheritMapFence')}}</div>
                                      <a-divider />
                                      <a-table :columns="fenceCloumns" :pagination="false" :dataSource="inheritFences">
                                          <template slot="opt" slot-scope="text">
                                              <span v-if="text == 1">{{$t('global.forbidIn')}}</span>
                                              <span v-if="text == 2">{{$t('global.forbidOut')}}</span>
                                          </template>

                                          <template slot="fenceType" slot-scope="text">
                                              <span v-if="text == 'circle'">{{$t('supervise.circle')}}</span>
                                              <span v-if="text == 'polygon'">{{$t('supervise.polygon')}}</span>
                                              <span v-if="text == 'district'">{{$t('supervise.district')}}</span>
                                          </template>

                                          <template slot="acls" slot-scope="text">
                                              <span>{{text ? aclFormat(text) : $t('global.none')}}</span>
                                          </template>

                                          <template slot="applyAll" slot-scope="text">
                                              <a-tag v-if="text" color="blue">{{$t('global.yes')}}</a-tag>
                                              <a-tag v-else color="gray">{{$t('global.no')}}</a-tag>
                                          </template>

                                          <template slot="operation" slot-scope="text,record">
                                              <a href="javascript:;" @click="updateFence(record, true)">{{$t('global.detail')}}</a>
                                          </template>
                                      </a-table>
                                    </div>
                                    
                                    <a-alert style="margin:0 0 5px 0" :message="$t('global.tips') + '：' + $t('supervise.fenceNumberTip')" type="info" showIcon></a-alert>
                                    <div v-if="ownFences && ownFences.length > 0"  >
                                      <!-- <div style="font-weight:500;font-size:18px">{{$t('supervise.ownedMapFence')}}</div> -->
                                      <!-- <a-divider />  -->

                                        <a-table :columns="fenceCloumns" :pagination="false" :dataSource="ownFences" :scroll="{  y: 487 }">
                                          <template slot="opt" slot-scope="text">
                                              <span v-if="text == 1">{{$t('global.forbidIn')}}</span>
                                              <span v-if="text == 2">{{$t('global.forbidOut')}}</span>
                                          </template>

                                          <template slot="fenceType" slot-scope="text">
                                              <span v-if="text == 'circle'">{{$t('supervise.circle')}}</span>
                                              <span v-if="text == 'polygon'">{{$t('supervise.polygon')}}</span>
                                              <span v-if="text == 'district'">{{$t('supervise.district')}}</span>
                                          </template>

                                          <template slot="acls" slot-scope="text">
                                              <span>{{text ? aclFormat(text) : $t('global.none')}}</span>
                                          </template>

                                          <template slot="applyAll" slot-scope="text">
                                              <a-tag v-if="text" color="blue">{{$t('global.yes')}}</a-tag>
                                              <a-tag v-else color="gray">{{$t('global.no')}}</a-tag>
                                          </template>

                                          <template slot="operation" slot-scope="text,record">
                                              <a-popconfirm :title="$t('global.confirm')" @confirm="deleteFence(record)">
                                                  <a href="javascript:;">{{$t('global.delete')}}</a>
                                              </a-popconfirm>
                                              <a-divider type="vertical" />
                                              <a href="javascript:;" @click="updateFence(record)">{{$t('global.edit')}}</a>
                                          </template>
                                      </a-table>
                                    </div>
                                    
                                </a-card>
                            </a-tab-pane>

                        </a-tabs>

                    </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import config from '@/config'
    import ZOrgChooser from '@/components/common/OrgChooser.vue'
    import ZUpdateTemplateBasic from '@/views/ruletemplate/UpdateTemplateBasic.vue'
    import ZUpdateBasicConfig from '@/views/ruletemplate/UpdateBasicConfig.vue'
    import ZUpdateSmartConfig from '@/views/ruletemplate/UpdateSmartConfig.vue'
    import ZAddRuleTemplate from '@/views/ruletemplate/AddRuleTemplate.vue'
    import ZEditFence from '@/views/ruletemplate/EditFence.vue'
    import moment from 'moment'
    import 'moment/locale/zh-cn';
    moment.locale('zh-cn')
    import {
        mapGetters
    } from 'vuex'


    export default {
        data() {
            return {
                templates: [],
                orgOption: {
                    value: ""
                },
                org: null,
                currentTemplate: null,
                fences: [],
                inheritFences: [],
                ownFences: []
            }
        },
        computed: {
            ...mapGetters([
                'isSuperAdmin',
                'roles'
            ]),
            fenceCloumns () {
              return [{
                      title: this.$t('supervise.fenceName'),
                      dataIndex: 'name',
                      key: 'name',
                      width: 150
                  },
                  {
                      title: this.$t('supervise.forbidType'),
                      dataIndex: 'opt',
                      key: 'opt',
                      "scopedSlots": {
                          "customRender": "opt"
                      },
                      width: 150
                  },
                  {
                      title: this.$t('supervise.timeOption'),
                      dataIndex: 'acl',
                      key: 'acl',
                      "scopedSlots": {
                          "customRender": "acls"
                      },
                      width: 150
                  },
                  {
                      title: this.$t('supervise.fenceType'),
                      dataIndex: 'type',
                      key: 'type',
                      "scopedSlots": {
                          "customRender": "fenceType"
                      },
                      width: 150
                  },
                  {
                      title: this.$t('supervise.applyChild'),
                      dataIndex: 'applyAll',
                      key: 'applyAll',
                      "scopedSlots": {
                          "customRender": "applyAll"
                      },
                      width: 150
                  },
                  {
                      "title": this.$t('global.action'),
                      "dataIndex": "operation",
                      "key": "operation",
                      "scopedSlots": {
                          "customRender": "operation"
                      },
                      width: 150
                  }
              ]
            }
        },
        created() {
            this.pageInit()
        },
        methods: {
            pageInit() {
                if (this.isSuperAdmin) {
                    this.$http.get(config.api.users_org_me_url).then((response) => {
                        if (response.code == 0) {
                            this.org = response.result.org
                            // console.log(this.org)
                            this.$http.get(config.api.entity_group_sa_url).then((response) => {
                                if (response.code == 0) {
                                    this.templates = response.result
                                    let _this = this
                                    this.templates.map((item) => {
                                        // console.log(item)
                                        // console.log(this.org.defaultEntityGroupId)
                                        if (item.entityGroup.id == this.org.defaultEntityGroupId) {
                                            this.currentTemplate = item
                                            this.fences = item.ruleTemplate[0].fences
                                            this.inheritFences = this.fences.filter((fence) => fence.allowChange === false)
                                            this.ownFences = this.fences.filter((fence) => fence.allowChange === true)
                                            // console.log(1)
                                        }
                                    })
                                    // console.log(this.templates)
                                }
                            })
                        }
                    })
                }
            },
            // 删除分组
            deleteGroup(groupId) {
                // console.log(groupId)
                this.$http.delete(config.api.delete_entity_group_config + groupId).then((res) => {
                    // console.log(res)
                    if (res.code === 0) {
                        this.$message.success('删除成功')
                        this.refreshTemplate(this.currentTemplate.entityGroup.id)
                        // this.pageInit()
                    } else {
                        this.$message.warning(res.desc)
                    }
                })
            },
            refreshTemplate(groupId) {
                // console.log(groupId)
                this.$http.get(config.api.entity_group_url + "/" + this.org.id).then((response) => {
                  
                    if (response.code == 0) {
                        this.templates = response.result
                        // let _this = this
                        this.templates.map((item) => {
                            if (item.entityGroup.id == groupId) {
                                this.currentTemplate = item
                                // 如果没有自动降频属性，那就默认设置为 true -》 自动降频开启
                                if (!this.currentTemplate.ruleTemplate[0].hasOwnProperty('autoAdjust')) {
                                    this.currentTemplate.ruleTemplate[0].autoAdjust = true
                                }
                                this.fences = item.ruleTemplate[0].fences
                                this.inheritFences = this.fences.filter((fence) => fence.allowChange === false)
                                this.ownFences = this.fences.filter((fence) => fence.allowChange === true)
                            }
                        })
                        // console.log(this.currentTemplate)
                    }
                })
            },
            addRuleTemplate() {
                this.$refs["addRuleTemplate"].showModel(this.org.id)
            },
            editTemplateBasic() {
                this.$refs["updateTemplateBasic"].showModel(this.clone(this.currentTemplate.entityGroup))
            },
            editBasicRule() {
                this.$refs["updateBasicConfig"].showModel(this.clone(this.currentTemplate.ruleTemplate[0]), this
                    .currentTemplate.entityGroup.id)
            },
            editSmartRule() {
                this.$refs["updateSmartConfig"].showModel(this.clone(this.currentTemplate.ruleTemplate[0]), this
                    .currentTemplate.entityGroup.id)
            },
            deleteFence(record) {
                this.$http.delete(config.api.rule_template_url + '/' + this.currentTemplate.ruleTemplate[0].id +
                    '/fence/' + record.id).then((response) => {
                    if (response.code == 0) {
                        this.$notification.success({
                          message: this.$t('supervise.操作成功')
                        })
                        this.refreshTemplate(this.currentTemplate.entityGroup.id)
                    } else {
                      this.$notification.error({
                        message: response.desc
                      })
                    }
                })
            },
            aclFormat(acl) {
                let acls = []
                // console.log(acl)
                acl.map(function (item) {
                    // let startTimestamp = item.split('~')[0]
                    // let endTimestamp = item.split('~')[1]
                    let [start, end] = item.split('~')
                    let startTime = moment(start * 1000).format("HH:mm")
                    let endTime = moment(end * 1000).format("HH:mm")
                    acls.push(startTime + '~' + endTime)
                })
                return acls.length > 0 ? acls.join('/') : '00:00~23:59'
            },
            updateFence(fence, onlyShow) {
                this.$refs["editFence"].showModel(this.currentTemplate.ruleTemplate[0].id, this.currentTemplate
                    .entityGroup.id, "edit", fence, onlyShow, this.org,this.currentTemplate.fenceIn,this.currentTemplate.fenceOut)
            },
            addFence() {
                this.$refs["editFence"].showModel(this.currentTemplate.ruleTemplate[0].id, this.currentTemplate
                    .entityGroup.id, "add",null ,null ,this.org,this.currentTemplate.fenceIn,this.currentTemplate.fenceOut)
            },
            formatTime(timestamp) {
                return moment(parseInt(moment().startOf('day').valueOf()) + timestamp * 1000).format("HH:mm")
            },
            setCurrent(template) {
                this.currentTemplate = template
                this.fences = template.ruleTemplate[0].fences
                this.inheritFences = this.fences.filter((fence) => fence.allowChange === false)
                this.ownFences = this.fences.filter((fence) => fence.allowChange === true)
            },
            changeDefaultGroup(groupId) {
                let _this = this
                this.$confirm({
                    title: this.$t('global.提示'),
                    content: this.$t('global.确认将'),
                    onOk() {
                        _this.$http.get(config.api.entity_group_default_url + '/' + groupId + '/org/' + _this
                            .org.id).then((response) => {
                            if (response.code == 0) {
                                _this.$message.success(_this.$t('global.successful'))
                                _this.org.defaultEntityGroupId = groupId
                            }
                        })
                    },
                    onCancel() {},
                });
            },
            onOrgSelect(org) {
                this.org = org
                // let _this = this
                this.$http.get(config.api.entity_group_url + "/" + org.id).then((response) => {
                    // console.log(1)
                    if (response.code == 0) {
                        this.templates = response.result
                        this.templates.map((item) => {
                            if (item.entityGroup.id == org.defaultEntityGroupId) {
                            //   console.log(item)
                                this.currentTemplate = item
                                // console.log(this.currentTemplate.ruleTemplate[0])
                                // console.log(this.currentTemplate.ruleTemplate[0].hasOwnProperty('autoAdjust'))
                                // 如果没有自动降频属性，那就默认设置为 true -》 自动降频开启
                                if (!this.currentTemplate.ruleTemplate[0].hasOwnProperty('autoAdjust')) {
                                    this.currentTemplate.ruleTemplate[0].autoAdjust = true
                                }
                                this.fences = item.ruleTemplate[0].fences
                                this.inheritFences = this.fences.filter((fence) => fence.allowChange === false)
                                this.ownFences = this.fences.filter((fence) => fence.allowChange === true)
                                // console.log(this.fences)
                            }
                        })
                        // console.log(this.templates)
                    }
                })
            },
            clone(obj) {
                if (null == obj || "object" != typeof obj) return obj;
                if (obj instanceof Date) {
                    let copy = new Date();
                    copy.setTime(obj.getTime());
                    return copy;
                }
                if (obj instanceof Array) {
                    let copy = [];
                    var len = obj.length;
                    for (var i = 0; i < len; ++i) {
                        copy[i] = this.clone(obj[i]);
                    }
                    return copy;
                }
                if (obj instanceof Object) {
                    let copy = {};
                    for (var attr in obj) {
                        if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
                    }
                    return copy;
                }
                throw new Error("Unable to copy obj! Its type isn't supported.");
            }
        },
        components: {
            ZEditFence,
            ZOrgChooser,
            ZUpdateTemplateBasic,
            ZUpdateBasicConfig,
            ZUpdateSmartConfig,
            ZAddRuleTemplate,
            ZEditFence
        }
    }
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
.chooser {
    display: grid;
    grid-template-columns: 80px 1fr;
    justify-content: space-around;
}
.group-list {
    overflow-y: auto;
    max-height: 81.5vh;
    // position: fixed;
}
.icon-custom {
  font-size: 2rem;
}
.avatar-icon {
  // background-color: rgba(151, 152, 153, 0.288);
  // box-shadow: .1px 0 1px #333;
  padding: 0 5px;
}
.current {
  // background: @primary-color;
  box-shadow: 0 2px 5px rgb(97, 97, 97);
}
</style>
